import { render, staticRenderFns } from "./space-course.vue?vue&type=template&id=10448c6b&scoped=true"
import script from "./space-course.vue?vue&type=script&lang=js"
export * from "./space-course.vue?vue&type=script&lang=js"
import style0 from "./space-course.vue?vue&type=style&index=0&id=10448c6b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10448c6b",
  null
  
)

export default component.exports